import Link from '@tiptap/extension-link'

export const A = Link.extend({
  addAttributes() {
    return {
      ...this.parent(),
      class: { default: null },
      style: { default: null },
    }
  }
})